<template>
    <v-dialog
        v-model="ui.dialog"
        persistent
        :width="$vuetify.breakpoint.smAndDown ? '100%' : '800px'"
    >
        <v-card :class="[$vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-4']">
            <v-card-title>
                Sincronización
            </v-card-title>
            <v-card-subtitle>
                Para realizar la sincronización debe selecciona un archivo en
                formato CSV.
            </v-card-subtitle>
            <v-card-text>
                <template v-if="!ui.sending">
                    <v-form
                        ref="form"
                        v-model="ui.valid"
                        lazy-validation
                        @submit.prevent="store()"
                    >
                        <v-row>
                            <v-col cols="12" v-if="pricelist.articles.length">
                                <v-alert type="warning" prominent text>
                                    Antes de realizar una sincronización es
                                    recomendable realizar una
                                    exportación(respaldo) previamente.
                                </v-alert>
                            </v-col>

                            <v-col cols="12" class="pb-0">
                                <v-file-input
                                    dense
                                    outlined
                                    v-model="file"
                                    :rules="[v.required]"
                                    label="Seleccionar archivo"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>

                <template v-else>
                    <v-row justify="center">
                        <v-col cols="2" class="d-flex justify-center pb-0">
                            <v-btn
                                fab
                                :color="
                                    ui.encoding === 'error'
                                        ? 'error'
                                        : 'primary'
                                "
                                text
                                :loading="ui.encoding === true"
                            >
                                <v-icon>
                                    {{
                                        ui.encoding === "error"
                                            ? "mdi-close"
                                            : "mdi-check"
                                    }}
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="4" class="d-flex align-center pb-0">
                            <h3>
                                Conversión
                            </h3>
                        </v-col>

                        <v-col cols="2" class="d-flex justify-center pb-0">
                            <v-btn
                                fab
                                :color="
                                    ui.updating === 'error'
                                        ? 'error'
                                        : 'primary'
                                "
                                text
                                :loading="ui.updating === true"
                            >
                                <v-icon v-if="ui.updating !== null">
                                    {{
                                        ui.updating === "error"
                                            ? "mdi-close"
                                            : "mdi-check"
                                    }}
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="4" class="d-flex align-center pb-0">
                            <h3>
                                Sincronización
                            </h3>
                        </v-col>
                    </v-row>

                    <v-row v-if="ui.updated" justify="center">
                        <v-col
                            cols="12"
                            class="pb-0 d-flex align-center justify-space-between"
                        >
                            <h3>
                                Resultados de la sincronización:
                            </h3>
                        </v-col>

                        <v-col cols="6" md="4" class="pb-0 black--text">
                            Agregados:
                            {{ results.attached.length }}
                        </v-col>
                        <v-col cols="6" md="4" class="pb-0 black--text">
                            Actualizados:
                            {{ results.updated.length }}
                        </v-col>
                        <v-col cols="6" md="4" class="pb-0 black--text">
                            Eliminados:
                            {{ results.detached.length }}
                        </v-col>
                        <v-col cols="6" md="4" class="pb-0 black--text">
                            Inexistentes:
                            {{ results.nonexistent.length }}
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>
            <v-card-actions class="d-flex justify-space-between">
                <div>
                    <v-btn
                        text
                        small
                        :loading="ui.downloading"
                        @click="layoutDownload()"
                    >
                        Descargar template
                    </v-btn>
                </div>
                <div>
                    <template v-if="!ui.updated">
                        <v-btn
                            color="primary"
                            text
                            @click="reset()"
                            :disabled="ui.sending === true"
                        >
                            cancelar
                        </v-btn>

                        <template v-if="ui.sending === null">
                            <v-btn
                                color="primary"
                                @click="store()"
                                :loading="ui.sending === true"
                                :disabled="!ui.valid"
                            >
                                enviar
                            </v-btn>
                        </template>

                        <template v-else>
                            <v-btn
                                color="primary"
                                @click="send()"
                                :loading="ui.sending === true"
                                :disabled="!ui.valid"
                            >
                                reintentar
                            </v-btn>
                        </template>
                    </template>

                    <template v-else>
                        <v-btn
                            text
                            class="mr-1"
                            color="primary"
                            :loading="ui.importResultsDownloading"
                            @click="downloadIportResults()"
                        >
                            descargar resultados
                        </v-btn>

                        <v-btn
                            color="primary"
                            @click="reset()"
                            :disabled="ui.importResultsDownloading"
                        >
                            ok
                        </v-btn>
                    </template>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import { mapState } from "vuex";

export default {
    props: ["pricelist"],

    data() {
        return {
            layout: { name: null },

            data: {
                importResults: [],
            },

            v: V,

            file: null,

            results: {
                attached: [],
                updated: [],
                detached: [],
                nonexistent: [],
            },

            default: {
                valid: true,
                dialog: false,
                sending: null,
                updated: false,
                updating: null,
                encoding: null,
                downloading: false,
            },

            ui: {
                importResultsDownloading: false,
            },
        };
    },

    created() {
        this.ui = Object.assign({}, this.default);

        EventBus.$on("MassImport", () => {
            this.ui.dialog = true;
        });
    },

    methods: {
        async store() {
            try {
                if (this.$refs.form.validate()) {
                    await this.send();
                }
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            }
        },

        async send() {
            try {
                this.ui.updating = null;
                this.ui.sending = true;

                let dataEncoded = await this.csvToArray();

                if (this.ui.encoding === "success") {
                    let results = await this.updateMassive(dataEncoded);

                    this.data.importResults = results;

                    if (this.ui.updating == "success") {
                        this.ui.sending = "success";
                        this.ui.updated = true;

                        return (this.results = results);
                    }
                } else {
                    return (this.ui.sending = "error");
                }

                this.ui.sending = null;
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
                this.ui.sending = "error";
            } finally {
                EventBus.$emit("ArticlePriceListGet");
            }
        },

        async layoutDownload() {
            this.ui.downloading = true;
            try {
                let response = await axios.post(
                    `${process.env.VUE_APP_API_SERVER}/export`,
                    {
                        data: [
                            {
                                id: null,
                                preferential_price: null,
                                preferential_discount: null,
                            },
                        ],
                        name: "Template lprecio",
                    }
                );

                window.open(response.data.data.downloadUrl, "_blank");
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {
                this.ui.downloading = false;
            }
        },

        async csvToArray() {
            try {
                this.ui.encoding = true;

                let formData = new FormData();

                formData.append("file", this.file);

                let response = await axios.post(
                    `${process.env.VUE_APP_API_SERVER}/csvtoarray`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${this.acount.token}`,
                        },
                    }
                );
                this.ui.encoding = "success";
                return response.data.data;
            } catch (error) {
                this.ui.encoding = "error";
                EventBus.$emit("Error", { error: error, errorsShow: true });
            }
        },

        async updateMassive(article_price_list) {
            try {
                this.ui.updating = true;

                let response = await axios.put(
                    `${process.env.VUE_APP_API_SERVER}/auth/pricelist/${this.$route.params.id}/articlepricelist/import`,
                    {
                        article_price_list: article_price_list,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${this.acount.token}`,
                        },
                    }
                );

                this.ui.updating = "success";

                return response.data.data;
            } catch (error) {
                this.ui.updating = "error";
                EventBus.$emit("Error", { error: error, errorsShow: true });
            }
        },

        reset() {
            this.file = null;

            this.ui = Object.assign(
                {},
                {
                    ...this.default,
                    dialog: false,
                }
            );
        },

        async downloadIportResults() {
            this.ui.importResultsDownloading = true;

            try {
                let resp = await axios.post(
                    `${process.env.VUE_APP_API_SERVER}/export`,
                    {
                        data: this.results,
                        mapType: "vertical",
                        name: `sync_results`,
                    }
                );

                window.open(resp.data.data.downloadUrl, "_blank");
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {
                this.ui.importResultsDownloading = false;
            }
        },
    },

    computed: {
        ...mapState(["acount"]),
    },
};
</script>

<style lang="css" scoped></style>
